import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box } from '@mui/material';
import { FC, useEffect, useRef, useState } from 'react';
// import { MuteOffIcon } from '../../common/assets/playerIcons/MuteOffIcon';
// import { MuteOnIcon } from '../../common/assets/playerIcons/MuteOnIcon';
import { EventNames } from '../../common/constants/constants';
// import { AuthFormStrings } from '../../common/localization/en';
import { useAppDispatch, useTypedSelector } from '../../store/store';
import {
  WelcomeVideoWrapper,
  WelcomeVideo,
  BtnWrapper,
  SkipIcon,
  SkipText,
  FadeOutBox,
} from './WelcomeVideo.styles';
import { setHideCrispChat } from '../../store/slices/ui';
import { useTrackEvent } from '../../common/hooks/useTrackEvent';
import { useTheme } from '@mui/material/styles';
import { useCrispChat } from '../../services/crisp/useCrispChat';

interface WelcomeVideoPageProps {
  handleNextStep: () => void;
}

export enum WelcomeVideoPageStrings {
  title = 'Wondering what to upload, watch this...',
}

const WelcomeVideoPage: FC<WelcomeVideoPageProps> = ({ handleNextStep }) => {
  const dispatch = useAppDispatch();
  const { trackEvent } = useTrackEvent();
  const {
    account: { id: accountId, name: accountName },
  } = useTypedSelector((state) => state.account);
  const { currentCampaign } = useTypedSelector((state) => state.rewards);
  const { firstName, lastName, email, phoneNumber } = useTypedSelector((state) => state.me);

  const { hideCrispChatToggle, showCrispChat } = useCrispChat();

  useEffect(() => {
    dispatch(setHideCrispChat(true));
    hideCrispChatToggle();
    return () => {
      dispatch(setHideCrispChat(false));
      showCrispChat();
    };
  }, []);

  // const [isWelcomeVideoMuted, setIsWelcomeVideoMuted] = useState(false);
  const [showSkipBtn, setShowSkipBtn] = useState(false);

  const refVideo = useRef<HTMLVideoElement | null>(null);
  // const muteBtnRef = useRef<HTMLButtonElement>(null);
  const theme = useTheme()

  const [lastTime, setLastTime] = useState(0);

  const handleSeeked = () => {
    const video = refVideo.current;
    if (!video) return;

    const currentTime = video.currentTime;
    if (currentTime > lastTime) {
      trackEvent({ action: EventNames.welcome_video_forward });
    } else if (currentTime < lastTime) {
      trackEvent({ action: EventNames.welcome_video_rewind });
    }
    setLastTime(currentTime);
  };

  useEffect(() => {
    dispatch(setHideCrispChat(true));
    trackEvent({ action: EventNames.welcome_video_page_view });
    return () => {
      dispatch(setHideCrispChat(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onVideoLoaded = async () => {
    if (!refVideo.current) {
      return;
    }

    refVideo.current.play();
  };

  const handleOnEnded = () => {
    if (refVideo.current) {
      refVideo.current.currentTime = refVideo.current.currentTime - 0.1;
      trackEvent({
        action: EventNames.welcome_video_watched,
        location: window.location.href,
        accountId,
        firstName,
        lastName,
        email: email,
        phoneNumber: phoneNumber,
      });
      handleNextStep();
    }
  };

  // const handleMutedClick = () => {
  //   setIsWelcomeVideoMuted((prevState) => !prevState);
  // };

  const handleSkipClick = () => {
    dispatch(setHideCrispChat(false));
    trackEvent({
      action: EventNames.SkipButtonClick,
      location: window.location.href,
      accountId,
      firstName,
      lastName,
      email: email,
      phoneNumber: phoneNumber,
      time: refVideo?.current?.currentTime,
    });
    trackEvent({
      action: EventNames.welcome_video_skipped,
      location: window.location.href,
      accountId,
      firstName,
      lastName,
      email: email,
      phoneNumber: phoneNumber,
      time: refVideo?.current?.currentTime,
    });

    handleNextStep();
  };

  useEffect(() => {
    setTimeout(() => {
      setShowSkipBtn(true);
    }, 4500);
  }, []);

  return (
    <WelcomeVideoWrapper
      style={{
        height: '100%',
        zIndex: 2,
      }}
    >
      <Box
        position="absolute"
        top="0"
        left="0"
        style={{
          // margin: '10px 16px',
          // zIndex: 3,
          height: 'var(--app-height)',
          width: '100%',
          pointerEvents: 'none',
          // backdropFilter: 'blur(10px)',
          // backgroundColor: 'rgba(255, 255, 255, 0.4)',
          // border: '1px solid #2D11AD',
          // borderRadius: '9px',
          // maxWidth: '540px',
        }}
      >
        <Box
          style={{
            width: '100%',
            maxWidth: '540px',
            margin: '0 auto',
            position: 'relative',
            height: 'var(--app-height)',
            pointerEvents: 'none',
          }}
        >
          <FadeOutBox
            $fadeOut={showSkipBtn}
            style={{
              margin: '10px 16px',
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(255, 255, 255, 0.4',
              border: `1px solid ${theme.palette.primary.main}`,
              borderRadius: '9px',
              height: '86px',
              padding: '9px 14px',
              zIndex: 3,
              minWidth: '333px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              pointerEvents: 'none',
            }}
          >
            <p
              style={{
                color: '#2D11AD',
                fontWeight: '700',
                fontSize: 'clamp(15px, 4.1vw, 22px)',
                lineHeight: 'clamp(20px, 5vw, 32px)',
                whiteSpace: 'nowrap',
                marginBottom: '5px',
              }}
            >
              {WelcomeVideoPageStrings.title}
            </p>
            <p
              style={{
                color: '#2D11AD',
                fontWeight: '700',
                fontSize: 'clamp(15px, 4.1vw, 22px)',
                lineHeight: 'clamp(20px, 5vw, 32px)',
                whiteSpace: 'nowrap',
                width: '100%',
                textAlign: 'right',
              }}
            >
              {`~ ${accountName}`}
            </p>
          </FadeOutBox>
        </Box>
      </Box>
      {/* <Box className={classes.banner}>
        <Typography className={classes.bannerTitle}>
          {firstName ? `${AuthFormStrings.Welcome} ${firstName}!` : 'Uploading a Great Video is Easy!'}
        </Typography>
        <Typography className={classes.bannerText}>Watch this video to learn more...</Typography>
      </Box> */}

      <BtnWrapper>
        {/* <IconButton ref={muteBtnRef} className={classes.muteIcon} size="small" onClick={handleMutedClick}>
          {isWelcomeVideoMuted ? <MuteOnIcon /> : <MuteOffIcon />}
        </IconButton> */}
        <div></div>

        {showSkipBtn && (
          <SkipIcon size="small" onClick={handleSkipClick}>
            <SkipText>Skip</SkipText>
            <ArrowForwardIcon fontSize="large" />
          </SkipIcon>
        )}
      </BtnWrapper>
      <WelcomeVideo
        playsInline
        onEnded={handleOnEnded}
        autoPlay={true}
        onPause={() => trackEvent({ action: EventNames.welcome_video_paused })}
        onPlay={() => trackEvent({ action: EventNames.welcome_video_played })}
        // muted={false}
        ref={refVideo}
        crossOrigin="anonymous"
        onLoadedData={onVideoLoaded}
        onSeeked={handleSeeked}
        poster={currentCampaign?.welcomeVideoUrl?.replace(/\....$/, '.jpg').replace('/upload/', '/upload/so_0,')}
        controls
        style={{ zIndex: '1' }}
      >
        <source src={currentCampaign?.welcomeVideoUrl} type="video/mp4" />
      </WelcomeVideo>
    </WelcomeVideoWrapper>
  );
};

export default WelcomeVideoPage;
